import { Organization } from "contexts/Organizations/types";

/**
 * The subdomain every personal space is served on. A personal organization has
 * no meta.subdomain of its own — there is one per b2c user — so they share
 * this one, which hegiasGo reserves (RESERVED_DOMAINS in config/domain.js): no
 * real organization can ever claim it. OrganizationsProvider selects the
 * user's personal space when the app is opened on it.
 */
export const PERSONAL_SPACE_SUBDOMAIN = "app";

/**
 * The subdomain an organization is reached on: its own, or the shared one for
 * a personal space. Anything that builds an organization's URL goes through
 * this — reading meta.subdomain directly is how a personal space ended up at
 * "undefined.<domain>".
 */
const organizationSubdomain = (
	organization?: Pick<Organization, "isPersonal" | "meta"> | null,
): string | undefined =>
	organization?.isPersonal
		? PERSONAL_SPACE_SUBDOMAIN
		: organization?.meta?.subdomain || undefined;

export default organizationSubdomain;
